export enum CivilStatusEnum {
  Single = 'SINGLE',
  Married = 'MARRIED',
  LivingCommonLaw = 'LIVING_COMMON_LAW',
  Divorced = 'DIVORCED',
  Separated = 'SEPARATED',
  Widowed = 'WIDOWED',

}
